// frontend/src/components/LanguageSwitcher.jsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'
import { useLanguage } from '../i18n/LanguageContext'
import { useTranslation } from '../i18n'

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage()
  const { _ } = useTranslation()

  const toggleLanguage = () => {
    const next = language === 'en' ? 'es' : 'en'
    setLanguage(next)
  }

  const ariaLabel = _('Change language')
  const title = language === 'en' ? _('Switch to Spanish') : _('Switch to English')

  return (
    <button
      onClick={toggleLanguage}
      className="icon-button-sm"
      aria-label={ariaLabel}
      title={title}
      type="button"
    >
      <FontAwesomeIcon icon={faGlobe} />
      <span className="sr-only">{ariaLabel}</span>
    </button>
  )
}
